import React, { useMemo, useState, useContext } from 'react'
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { KPI } from 'src/mtska-frontend-app-component';
import { useSettingsContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';

const FleetManagerCarKPI = ({ filters, setFilters, userCapabilities }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">
            {
                userCapabilities && userCapabilities['auth/role.is_superuser'] && (
                    <KPI
                        title="Vehicles"
                        icon="faCars"
                        dataProviderName={'statisticsviews/item/count/cars/car'}
                        className="superuserData"
                    />
                )
            }
            <KPI
                title="running"
                icon="faCar"
                dataProviderName={'statisticsviews/running/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "status",
                        operator: "equals",
                        value: "running"
                    }]
                }}
            />
            <KPI
                title="available"
                icon="faShop"
                dataProviderName={'statisticsviews/available/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "status",
                        operator: "equals",
                        value: "available"
                    }]
                }}
            />
            <KPI
                title="in_order"
                icon="faCartShopping"
                dataProviderName={'statisticsviews/order/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "status",
                        operator: "equals",
                        value: "in_order"
                    }]
                }}
            />
            <KPI
                title="in_offer"
                icon="faHandshake"
                dataProviderName={'statisticsviews/offer/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "status",
                        operator: "equals",
                        value: "in_offer"
                    }]
                }}
            />
            <KPI
                title="in_configuration"
                icon="faPencil"
                dataProviderName={'statisticsviews/configuration/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "status",
                        operator: "equals",
                        value: "in_configuration"
                    }]
                }}
            />
            <KPI
                title="closed"
                icon="faFolder"
                dataProviderName={'statisticsviews/closed/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "status",
                        operator: "equals",
                        value: "closed"
                    }]
                }}
            />
            <KPI
                title="canceled"
                icon="faFolder"
                dataProviderName={'statisticsviews/closed/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "status",
                        operator: "equals",
                        value: "canceled"
                    }]
                }}
            />
        </Box>
    </>, [filters])

}

export default FleetManagerCarKPI;


